/* eslint-disable camelcase */
/* eslint-disable no-console */
import { EUROPEAN_CONTRIES } from '~/config'
import loadScript from '~/utils/loadScript'
import Cookie from '~/utils/Cookie'

const COOKIEBOT_SCRIPT_SRC = 'https://consent.cookiebot.com/uc.js'

export default ({ $userReady, $isGlobalStore }, inject) => {
  console.log('[cookiebot] init plugin')

  let triggerUserConsent = null
  const onUserConsent = new Promise((resolve) => {
    triggerUserConsent = resolve
  })

  /**
   * Load Cookiebot script when user info is ready.
   */
  if ($isGlobalStore) {
    $userReady.then((user) => {
      if (EUROPEAN_CONTRIES.includes(user?.country_id)) {
        console.log('[cookiebot] loading cookiebot script', { user })

        const consentLocale =
          window?.$nuxt?.$route?.query?.language ||
          Cookie.Client(document.cookie).get('v4_locale')

        const options = {
          once: true,
          attrs: {
            async: true,
            id: 'Cookiebot',
            'data-cbid': '9ddc0566-a9fc-46f4-8360-081d8fb466df',
            'data-culture': consentLocale,
          },
        }

        window.addEventListener(
          'CookiebotOnConsentReady',
          function () {
            triggerUserConsent({
              consented: window.Cookiebot.consented,
              reason: 'user consent',
            })
          },
          false
        )

        loadScript(COOKIEBOT_SCRIPT_SRC, options).catch((err) => {
          /**
           * By default trigger user consent on error
           */
          triggerUserConsent({
            consented: true,
            reason: 'cookiebot script load error',
          })

          console.log('[cookiebot] cookiebot script loading error', err)
        })
      } else {
        // Accept cookies by default for non-europeans countries
        triggerUserConsent({ consented: true, reason: 'not european country' })
      }
    })
  } else {
    /**
     * Enable user conset by default for BR store
     */
    triggerUserConsent({ consented: true, reason: 'not global store' })
  }

  /**
   * Resolves $onUserConsent promise when user accept or decline cookies
   */
  inject('triggerUserConsent', triggerUserConsent)
  /**
   * Promise that resolves when user accept or decline cookies. vc
   */
  inject('onUserConsent', onUserConsent)
}
